module.exports = __webpack_public_path__ + "img/boton-abajo.c97c866a.svg";